import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import './style.css';

function Tooltip({ children }, ref) {
	const [show, setShow] = useState(false);
	const [position, setPosition] = useState({ x: 0, y: 0 });

	const lastTimeout = useRef(null);

	useImperativeHandle(ref, () => ({
		Show: ({ x, y, timeout = 3500 }) => {
			setShow(true);
			setPosition({ x, y });
			if (lastTimeout.current) clearTimeout(lastTimeout.current);
			lastTimeout.current = setTimeout(() => {
				setShow(false);
			}, timeout);
		},
	}));

	if (show)
		return (
			<div className="Tooltip" style={{ top: position.y, left: position.x }}>
				{children}
			</div>
		);
	return null;
}

export default forwardRef(Tooltip);
